import { Roles } from '../../../cimsPage/instances/admin'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const roles = CreateViewEditSoftRemoveRestore({
  page: Roles,
  object: 'Role',
  create: 'A7456A35-8061-4890-AD06-FF3270DF1358',
  view: 'B0451D72-D402-402E-B66F-326BA1925529',
  edit: '82D7DD29-6E2B-449F-B274-26FB144F99C7',
  removeRestore: 'E7BF4F27-CBF4-45B2-899D-6AEEFC9B9C24',
})

export const CreateRole = roles.Create
export const ViewRole = roles.View
export const EditRole = roles.Edit
export const RemoveRestoreRole = roles.RemoveRestore

export type RolePermission =
  | typeof CreateRole
  | typeof ViewRole
  | typeof EditRole
  | typeof RemoveRestoreRole
